document.addEventListener("DOMContentLoaded", () => {
  const menuPairs = document.querySelectorAll(".menu-flyout-wrapper");

  menuPairs.forEach((trigger) => {
    const dropdown = trigger.nextElementSibling;
    const items = dropdown.querySelectorAll(".menu-flyout-item");
    const allSubmenus = dropdown.querySelectorAll(
      ".menu-flyout-submenu-content"
    );
    const allSubsubmenus = dropdown.querySelectorAll(".menu-flyout-level3");

    if (!items.length) return;

    const firstItem = items[0];
    const firstSubmenuId = firstItem.dataset.submenuId;

    // Show default submenu (2nd level)
    firstItem.classList.add("is-active");
    allSubmenus.forEach((sub) => {
      sub.style.display =
        sub.dataset.submenu === firstSubmenuId ? "block" : "none";
    });

    // Hover over 1st level item
    items.forEach((item) => {
      const submenuId = item.dataset.submenuId;

      item.addEventListener("mouseenter", () => {
        allSubmenus.forEach((sub) => {
          sub.style.display =
            sub.dataset.submenu === submenuId ? "block" : "none";
        });

        allSubsubmenus.forEach((subsub) => {
          subsub.style.display = "none";
        });

        items.forEach((i) => i.classList.remove("is-active"));
        item.classList.add("is-active");
      });

      const link = item.querySelector(".menu-flyout-link");
      const hasSubmenu = dropdown.querySelector(
        `.menu-flyout-submenu-content[data-submenu="${submenuId}"]`
      );

      if (link && hasSubmenu) {
        let tappedOnce = false;

        link.addEventListener("click", function (e) {
          if (window.innerWidth >= 768 && window.innerWidth <= 1024) {
            if (!tappedOnce) {
              e.preventDefault();
              tappedOnce = true;
              item.dispatchEvent(new Event("mouseenter"));

              setTimeout(() => {
                tappedOnce = false;
              }, 800);
            }
          }
        });
      }
    });

    // Hover over 2nd level subitem
    const subitems = dropdown.querySelectorAll(".menu-flyout-subitem");

    subitems.forEach((subitem) => {
      const subsubmenuId = subitem.dataset.subsubmenuId;

      subitem.addEventListener("mouseenter", () => {
        allSubsubmenus.forEach((subsub) => {
          subsub.style.display =
            subsub.dataset.subsubmenu === subsubmenuId ? "block" : "none";
        });

        subitems.forEach((i) => i.classList.remove("is-active"));
        subitem.classList.add("is-active");
      });
    });

    // Hover persistence
    let hideTimeout;

    function showDropdown() {
      clearTimeout(hideTimeout);
      dropdown.style.display = "flex";
    }

    function hideDropdown() {
      hideTimeout = setTimeout(() => {
        if (!trigger.matches(":hover") && !dropdown.matches(":hover")) {
          dropdown.style.display = "none";
        }
      }, 100);
    }

    trigger.addEventListener("mouseenter", showDropdown);
    trigger.addEventListener("mouseleave", hideDropdown);
    dropdown.addEventListener("mouseenter", showDropdown);
    dropdown.addEventListener("mouseleave", hideDropdown);
  });
});
